import { Befehl4 } from '../../../models'
import { Befehl4FormData, Befehl4FormSchema } from './schema'
import { findAuftragByKennung } from '../converter-utils'
import { Befehl4DataDto } from '../../../dtos/befehl-4-dto'

export const convertModelToBefehl4FormData = (
  befehl?: Befehl4
): Befehl4FormData => {
  const formData = Befehl4FormSchema.parse({})

  if (!befehl) {
    return formData
  }

  // For Befehl4, enabled is not changeable by user, so we keep it as true
  // even when model has empty auftraege array
  if (befehl.auftraege?.length === 0) {
    // For Befehl4, we don't disable auftrag_4_10 even when empty
    return formData
  }

  if (!befehl.auftraege) {
    return formData
  }

  // Auftrag 4.10
  const auftrag410 = findAuftragByKennung(befehl.auftraege, '4.10')
  if (auftrag410) {
    // enabled not changeable by user when auftrag exists
    formData.auftrag_4_10.enabled = true
    const kennung = auftrag410.felder?.[0]?.werte?.eindeutigeKennung
    if (kennung) {
      formData.auftrag_4_10.field_4_11.eindeutigeKennung = kennung
    }
  }
  // Note: For Befehl4, enabled stays true even when auftrag is missing

  return formData
}

export const convertBefehl4FormDataToModel = (
  formData: Befehl4FormData,
  frontendId: string
): Befehl4 => {
  const auftraege: Befehl4DataDto = []

  if (formData.auftrag_4_10?.enabled) {
    auftraege.push({
      kennung: '4.10',
      felder: [
        {
          kennung: '4.11',
          werte: {
            eindeutigeKennung:
              formData.auftrag_4_10?.field_4_11?.eindeutigeKennung
          }
        }
      ]
    })
  }

  return {
    kennung: '4',
    frontendId,
    auftraege
  }
}
